import Model from 'src/models/Model'

export const COMPUTED_TYPE = {
  AVERAGE: 'average',
  RATIO: 'ratio',
  PERCENT: 'percent',
  SHARE_PERCENT: 'share_percent',
  GROUP_SHARE_PERCENT: 'group_share_percent',
  MIN_BY: 'min_by',
  MAX_BY: 'max_by'
}
export default class ReportTableColumn extends Model {
  static name = 'ReportTableColumn'

  static define () {
    this.fields = {
      label: {
        type: String,
        computed () {
          if (this.data.label) return this.data.label

          return _.startCase(this.field)
        }
      },
      field: {
        type: String
      },
      component: {
        type: String
      },
      category: {
        type: String
      },
      definition: {
        type: String
      },
      align: {
        type: String
      },
      sortable: {
        type: Boolean
      },
      groupable: {
        type: Boolean
      },
      filterable: {
        type: Boolean
      },
      hideTotals: {
        type: Boolean
      },
      aggregate: {
        type: Boolean
      },
      summable: {
        type: Boolean
      },
      averagable: {
        type: Boolean
      },
      computedType: {
        type: String
      },
      sourceField: {
        type: String
      },
      numerator: {
        type: String
      },
      denominator: {
        type: String
      },
      sensitive: {
        type: Boolean
      },
      style: {
        type: String
      },
      width: {
        type: String
      },
      maxWidth: {
        type: String
      },
      minWidth: {
        type: String
      },
      classes: {
        type: String
      },
      headerStyle: {
        type: String
      },
      headerClasses: {
        type: String
      },
      hide: {
        type: Boolean
      }
    }
  }

  get name () {
    return this.label
  }

  calculateValue (row) {
    let value
    switch (this.computedType) {
      case COMPUTED_TYPE.AVERAGE: {
        value = (row[this.sourceField] || 0) / (row.row_count || 1)
        return isNaN(value) ? null : value
      }
      case COMPUTED_TYPE.RATIO:
        if (!row[this.denominator]?.value || row[this.denominator]?.value === 0) {
          return null
        }
        return (row[this.numerator]?.value || 0) / row[this.denominator]?.value
      case COMPUTED_TYPE.PERCENT:
        if (!row[this.denominator]?.value || row[this.denominator]?.value === 0) {
          return null
        }
        return (row[this.numerator]?.value || 0) / row[this.denominator]?.value * 100
      case COMPUTED_TYPE.GROUP_SHARE_PERCENT:
        return row[this.field]?.value
      case COMPUTED_TYPE.SHARE_PERCENT:
        return row[this.field]?.value
      case COMPUTED_TYPE.MIN_BY:
        return row[this.sourceField]?.value
      case COMPUTED_TYPE.MAX_BY:
        return row[this.sourceField]?.value
      default:
        throw new Error('Unhandled Calculated Type: ' + this.computedType)
    }
  }
}
